
import { Vue, Component } from "vue-property-decorator";
import { SupportFabricOption } from "../pending/definations";
import { CapacityData, FabricCapacity } from "./definations";
import {
  getSupplierReportCapacityFabric,
  getSupplierReportCapacityList,
} from "@/service/ewold/api/supplierReportCapacity";
import { SupplierReportCapacityResponseDTO } from "@/service/ewold/entity/SupplierReportCapacityResponseDTO";
import { categoryNameSeparator } from "../definations";
import MonthCapacityStatus from "../components/monthCapacityStatus/index.vue";
@Component({
  components: {
    MonthCapacityStatus,
  },
})
export default class CapacitySubmitted extends Vue {
  form = {
    items: [],
  };
  tableData: CapacityData[] = [];
  pageIndex = 1;
  pageSize = 20;
  count = 0;
  loading = false;
  fabricColumns: SupportFabricOption[] = [];
  supportFabricOptions: SupportFabricOption[] = [];
  ready = false;
  async mounted() {
    this.supportFabricOptions = await this.getSupportFabricOptions(); // 表格数据依赖该数据
    this.ready = true;
    this.search();
  }
  async getSupportFabricOptions() {
    const res = await getSupplierReportCapacityFabric();
    if (Array.isArray(res.result)) {
      return res.result.map((ele) => ({
        label: ele.desc,
        value: ele.code + "",
      }));
    }
    return [];
  }
  search() {
    this.query();
  }
  async query() {
    this.loading = true;
    const res = await getSupplierReportCapacityList({
      page_index: this.pageIndex,
      page_size: this.pageSize,
    });
    this.loading = false;
    if (res.is_success && res.result) {
      this.count = res.result.total_count || 0;
      if (Array.isArray(res.result.items)) {
        this.formatResData(res.result.items);
      }
    }
  }
  getNameByFabricKey(key: string) {
    const match = this.supportFabricOptions.find((ele) => ele.value === key);
    return match?.label || "";
  }
  genCapacityFabricsInfo(
    item: SupplierReportCapacityResponseDTO,
    values: string[]
  ): { [x: string]: FabricCapacity } {
    const supportList = item.fabric_support_list;
    const info: { [x: string]: FabricCapacity } = {};
    supportList.forEach((fabricKey, index) => {
      info[fabricKey] = {
        key: fabricKey,
        name: this.getNameByFabricKey(fabricKey),
        value: values[index] || "",
      };
    });
    return info;
  }
  formatResData(data: SupplierReportCapacityResponseDTO[]) {
    // 算出支持的所有面料，生成面料表头
    const fabricColumns: SupportFabricOption[] = [];
    const fabricMap: Map<string, boolean> = new Map();
    this.supportFabricOptions.forEach((ele) => {
      fabricMap.set(ele.value + "", false);
    });
    const tableData: CapacityData[] = [];
    data.forEach((ele) => {
      const supportFabrics = ele.fabric_support_list;
      supportFabrics.forEach((f) => {
        fabricMap.set(f, true);
      });
      tableData.push({
        reportMonth: ele.report_month,
        categoryNameList: ele.main_product_category_name_list,
        categoryIdList: ele.main_product_category_id_list,
        status: ele.status,
        daily: {
          fabrics: this.genCapacityFabricsInfo(
            ele,
            ele.fabric_month_capacity_factory_list
          ),
          monthReorder: ele.monthly_reorder_factory + "",
          monthNewProduct: ele.monthly_new_designs_factory + "",
        },
        banggood: {
          fabrics: this.genCapacityFabricsInfo(
            ele,
            ele.fabric_month_capacity_banggu_list
          ),
          monthReorder: ele.monthly_reorder_banggu + "",
          monthNewProduct: ele.monthly_new_designs_banggu + "",
        },
        workDays: ele.work_days,
        createDate: ele.create_date,
        remark: ele.remark,
      });
    });
    this.supportFabricOptions.forEach((opt) => {
      if (fabricMap.get(opt.value + "") === true) {
        fabricColumns.push({
          ...opt,
        });
      }
    });

    this.tableData = tableData;
    this.fabricColumns = fabricColumns;
  }
  getCategoryLastLevelName(fullName: string) {
    return (fullName || "").split(categoryNameSeparator).pop();
  }
}
